module.exports = __webpack_public_path__ + "img/id-card.346cf4c1.svg";